import React, { useEffect } from 'react';
import AlertMessage from '../../AlertMessage';
import { useRequestHook } from '../../../utils/hooks/hooks';
import { connect } from 'react-redux';

const BoardAlert = ({ data, dismiss, docId }) => {
	const { handleRequest } = useRequestHook(); //Define method to fetch data.

	useEffect(() => {
		let abort
		if (data) {
			const { reference } = document.getElementById('detect-types-form')?.elements;
	
			if (
				reference.classList.contains('is-valid') && 
				data.msg === 'Diese Referenz ist nicht gültig!'
			) {
				console.log('')
				console.log('')
				console.log('Fehler!!!')
				console.log("reference.classList.contains('is-valid')", reference.classList.contains('is-valid'))
				console.log('data.msg', data.msg)
				console.log('')
				console.log('')
	
				const { value } = reference
	
				if (abort) return

				handleRequest(
					'post',
					'/thumbnails/catch-bug',
					{
						docId,
						logs: [
							`reference.classList.contains('is-valid'): ${reference.classList.contains('is-valid')}`,
							`data.msg: ${data.msg}`,
							`reference: ${value}`
						]
					},
					(response) => {
						console.log(response)
					}
				)
			}
		}
	
	  return () => {
		abort = true
	  }
	}, [data])
	

	if (!data) return null;



	return (
		<div className='detect-types-alert'>
			<AlertMessage alertMessage={data.msg} background={data.background} manualDismiss={{ dismissible: dismiss }} />
		</div>
	);
};

const mapStateToProps = ({ savedDocument: { id: docId } }) => {

	return { docId }
}

export default connect(mapStateToProps)(BoardAlert)